import { getRegionsAndProvinces, getMunicipality, getSheets, getParcels, getMunicipalityParcels } from '@/api/services.js';

// --------------------- STATE -----------------------------

export const state = {
  regions_and_provinces: [],
  municipality_list: [],
  parcels_list: [],
  sheets_list: []
};

// --------------------- MUTATIONS ----------------------------

export const mutations = {
  SET_REGIONS_AND_PROVINCES(state, data) {
    state.regions_and_provinces = data;
  },
  SET_MUNICIPALITY_LIST(state, data) {
    state.municipality_list = data.sort((a, b) =>
      a.name.localeCompare(b.name, 'it', { numeric: true, sensitivity: 'base' })
    );
  },
  SET_SHEETS_LIST(state, data) {
    state.sheets_list = data.sort((a, b) =>
      a.sheetId.localeCompare(b.sheetId, 'it', { numeric: true, sensitivity: 'base' })
    );
  },
  SET_PARCELS_LIST(state, data) {
    state.parcels_list = data.sort((a, b) =>
      a.parcelId.localeCompare(b.parcelId, 'it', { numeric: true, sensitivity: 'base' })
    );
  }
};

// ------------------------ ACTIONS ---------------------------
export const actions = {
  async getRegionsAndProvincesList({ commit, dispatch }) {
    try {
      const resp = await getRegionsAndProvinces();
      commit('SET_REGIONS_AND_PROVINCES', resp.data);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'getRegionsAndProvinces',
          errObj: {
            errors: [{ message: 'Error while fetching Cadastral Api.' }]
          },
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async getMunicipalityList({ commit, dispatch }, data) {
    const { regionCode, provinceCode } = data;

    try {
      const resp = await getMunicipality(regionCode, provinceCode);
      commit('SET_MUNICIPALITY_LIST', resp.data);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'getMunicipality',
          errObj: {
            errors: [{ message: 'Error while fetching Cadastral Api.' }]
          },
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async getSheetsList({ commit, dispatch }, municipalityCode) {
    try {
      const resp = await getSheets(municipalityCode);
      commit('SET_SHEETS_LIST', resp.data);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'getSheets',
          errObj: {
            errors: [{ message: 'Error while fetching Cadastral Api.' }]
          },
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async getParcelsList({ commit, dispatch }, data) {
    const { municipalityCode, sheetCode, regionCode } = data;

    try {
      const resp = await getParcels(municipalityCode, sheetCode, regionCode);
      commit('SET_PARCELS_LIST', resp.data);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'getParcels',
          errObj: {
            errors: [{ message: 'Error while fetching Cadastral Api.' }]
          },
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async getMunicipalityParcelsList({ commit, dispatch }, data) {
    const { municipalityCode, provinceCode } = data;

    try {
      commit('SET_SHEETS_LIST', []);

      const resp = await getMunicipalityParcels(municipalityCode, provinceCode);
      commit('SET_PARCELS_LIST', resp.data);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'getMunicipalityParcels',
          errObj: {
            errors: [{ message: 'Error while fetching Cadastral Api.' }]
          },
          type: 'danger'
        },
        { root: true }
      );
    }
  }
};

export const getters = {};
